<script>
    import { chatMessages } from "../../stores.js";
    export let openChat;
    $: hasUnread = $chatMessages.unread > 0;
</script>

<div class="chat badge">
    <i class="fa-thin fa-messages" class:active={openChat}></i>
    {#if hasUnread}
        <div class="new-msg-indicator"></div>
    {/if}
</div>

<style lang="scss">
    
    @import "../styles/variables.scss";

    .new-msg-indicator {
        position: absolute;
        top: 4px;
        left: 25px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: $accent-color;
        color: $accent-color;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .chat {
        display: block;
    }
  
    .badge {
        position: relative;
    }

    // .fa-messages {
    //     &.active {
    //         // color: #475175;
    //         box-shadow: none;
    //     }
    // }



</style>